import React from 'react';
import { FormikProps } from 'formik';
import ATMLoadingButton from 'src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton';
import ATMTextField from 'src/components/UI/atoms/formFields/ATMTextField/ATMTextField';

type Props = {
  formikProps: FormikProps<any>;
  onClose: () => void;
};

const ApplyCoupon = ({ formikProps, onClose }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  return (
    <div className='p-4 flex flex-col gap-6'>
      <div className='flex justify-between items-center'>
        <div className='text-xl font-medium'> Coupon </div>
        <button type='button' className='hover:bg-hover' onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className='flex flex-col gap-4'>
        <div>
          <ATMTextField
            name='couponCode'
            value={values.couponCode}
            onChange={(e) => {
              setFieldValue('couponCode', e.target.value);
            }}
            label='Coupon Code'
            onBlur={handleBlur}
          />
        </div>
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type='submit'>
          Apply
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default ApplyCoupon;